export enum ConfigurationTypes {
    GET_CONFIGURATIONS_REQUEST = 'GET_CONFIGURATIONS_REQUEST',
    GET_CONFIGURATIONS_REQUEST_SUCCESS = 'GET_CONFIGURATIONS_REQUEST_SUCCESS',
    GET_CONFIGURATIONS_REQUEST_FAILURE = 'GET_CONFIGURATIONS_REQUEST_FAILURE',
}